import React from 'react';
import Collapsible from '../Collapsible';
import EditorString from '../EditorString/EditorString';
import { FAQItems } from '../../Types/ProductPageModel';

const ProductPageFAQTab = ({
  items,
  show,
}: {
  items: FAQItems[];
  show: boolean;
}) => {
  return show ? (
    <div className="w-1/2 md-down:w-full [&>div:first-of-type]:border-t">
      {items.map(
        (faq, idx) =>
          faq.title && (
            <Collapsible
              className="w-full border-b border-gray-100 transition"
              key={faq.title + idx}
              label={faq.title}
              labelClassName="h3 !text-h3-mobile"
              labelSize="h-4 w-4"
              contentClassName="[&_.ReactCollapse--collapse[aria-hidden='false']]:pb-6 [&_.ReactCollapse--collapse]:transition-all"
            >
              {faq.text.value && <EditorString value={faq.text?.value} />}
            </Collapsible>
          )
      )}
    </div>
  ) : null;
};

export default ProductPageFAQTab;
